<script setup lang="ts">
import { NModal, NButton } from 'naive-ui'

defineProps<{ show: boolean; vehicleName: string }>()
const emit = defineEmits<{
  'update:show': [boolean]
  confirm: []
}>()

function confirm() {
  emit('confirm')
}
function cancel() {
  emit('update:show', false)
}
</script>

<template>
  <n-modal
    :show="show"
    preset="dialog"
    title="Удалить машину?"
    style="width: 460px; max-width: 95vw"
    @update:show="$emit('update:show', $event)"
  >
    <p>
      Удалить машину <strong>{{ vehicleName }}</strong>? Будет также удалена вся её
      история детекций и телеметрия. Действие необратимо.
    </p>
    <template #action>
      <n-button data-action="cancel" @click="cancel">Отмена</n-button>
      <n-button type="error" data-action="confirm" style="margin-left: 8px" @click="confirm">
        Удалить
      </n-button>
    </template>
  </n-modal>
</template>
